/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener("DOMContentLoaded", function() {
  // Native App adjustments
  var userAgent = window.navigator.userAgent;
  if (userAgent.includes("BonaAPP")) {
    document.getElementById("section-header").style.display = "none";
    document.getElementById("shopify-section-footer").style.display = "none";
    document.getElementById("shopify-section-announcement").style.display = "none";
  }

  if (sessionStorage.checkFormActive == 1) {
    if (window.location.href.indexOf('/account/register') != -1) {
      sessionStorage.checkFormActive = 0;
      window.location.href = '/pages/thanks-account-registration';
    }
  }

  var elements = document.getElementsByTagName("input");
  for (var i = 0; i < elements.length; i++) {
    elements[i].oninvalid = function(e) {

      e.target.classList.remove("input_invalid");
      e.target.setCustomValidity("");
      if (!e.target.validity.valid) {
        e.target.setCustomValidity(" ");
        e.target.classList.add("input_invalid");
      }
    };
    elements[i].oninput = function(e) {
      e.target.setCustomValidity("");
      e.target.classList.remove("input_invalid");
    };
  }
})

$(document).ready(function(){
  $('.btn-register').on('click', function(e){
    sessionStorage.checkFormActive = 0;
  });

  $('.btn-active-account').on('click', function(e){
    e.preventDefault();
    sessionStorage.checkFormActive = 1;
    $('.modal-message-sent-password').fadeIn('slow', function(){
      setTimeout(function(){
        $('#active_account').submit();
      }, 800);
    });
  });
});

(function() {
  if (window.theme.template === 'collection') {
    var loadSwatches = function () {
      $('[data-load-swatches]').each(function (index, item) {
        var url = '/products/' + item.getAttribute('data-load-swatches') + '?section_id=product-collection-swatches';

        fetch(url).then(function (response) {
          response.text().then(function (content) {
            $(item).html(content);
          });
        });
      });
    }

    loadSwatches();

    // On collection page we hook the theme:loading:end (which happesn when a tag is applied)
    document.addEventListener('theme:loading:end', function () {
      loadSwatches();
    });
  }
})(); 